import React from "react";
import aboutimg from "../image/dharajbanner.jpg";
import "bootstrap/dist/css/bootstrap.min.css";  
import FounderSection from "./founderSection";
import  Blog from "./Blog";
import DeliverySlide from "./deliverySlide";
import FarmersVideo from "./framevideo";
import Help from "./Help";
import PrivacyPolicy from "./PrivacyPolicy"
import Promisepage from "./Promisepage"
import Settings from "./Setting"
 
import Terms from "./TermsAndConditions"
 

export default function AboutUs() {
  return (
    <div>
      {/* HERO */}
      <section className="position-relative" style={{ height: "80vh", overflow: "hidden" }}>
        <img
          src={aboutimg}
          alt="Farm background"
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-end px-5"
          style={{
            background:
              "linear-gradient(to left, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0.1) 100%)",
          }}
        >
          <div className="text-start" style={{ maxWidth: 500, color: "#003333" }}>
            <h2 className="montserrat montserrat-400 fs-xxxl">
              Delivering <span className="montserrat montserrat-700">Purity &amp; Health</span>
            </h2>
            <p className="montserrat montserrat-400 fs-xl">
              From Our Farm To Help You Lead Happy,
              <br />
              Healthy &amp; Organic Life
            </p>
          </div>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="container py-5 bg-light">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <img src={aboutimg} alt="Our Team" className="img-fluid rounded-3" />
          </div>
          <div className="col-lg-6">
            <h2 className="montserrat montserrat-700 fs-xxxl">Who We Are?</h2>
            <p className="montserrat montserrat-400 fs-xl mb-4">
              <strong>GirOrganic</strong> was founded in 1990 with the aim of introducing an
              organic lifestyle to the world. Started with mere 5–6 cows, today we have
              more than 450 Gir Cows at our certified organic farm spread over 500+ acres
              in Surat, Chotta Udaipur. All our products are made by following organic
              farming and manufacturing practices ensuring no harm is provided to the
              environment and your health.
            </p>
            <div className="d-flex flex-wrap gap-4">
              <div className="text-center">
                <div
                  className="montserrat montserrat-800 fs-xxl"
                  style={{
                    backgroundColor: "rgba(255,205,92,0.3)",
                    borderRadius: "50%",
                    padding: "10px 20px",
                  }}
                >
                  450+
                </div>
                <div className="montserrat montserrat-600">Gir Cows</div>
              </div>
              <div className="text-center">
                <div
                  className="montserrat montserrat-800 fs-xxl"
                  style={{
                    backgroundColor: "rgba(255,205,92,0.3)",
                    borderRadius: "50%",
                    padding: "10px 20px",
                  }}
                >
                  500+
                </div>
                <div className="montserrat montserrat-600">Acres Organic Farm</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PURE LOVE */}
      <section className="container py-5 bg-warning bg-opacity-10">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h2 className="montserrat montserrat-700 fs-xxxl">Pure Love</h2>
            <h4 className="montserrat montserrat-600 fs-xl mb-3">Our Unconditional Love For Our Cows</h4>
            <p className="montserrat montserrat-400 fs-xl">
              The cows are fed with nutritionally rich fodder grown at our farm organically
              & are free of any supplements or medications. The calves have the first right
              to their mother’s milk. The cowshed is cleaned twice a day & has 24/7 medical
              support to tackle any emergency. Water sprinklers are installed to lower heat
              in summers. We even treat our cows with music therapy as we play soulful
              classical music in the cowshed. Studies suggest music enhances their mental
              and physical health. We love our cows more than anything in the world.
            </p>
          </div>
          <div className="col-lg-6">
            <img
              src="https://girorganic.com/cdn/shop/files/Vector_Smart_Object.png?v=1698640263"
              alt="Cow with calf"
              className="img-fluid"
              style={{
                maskRepeat: "no-repeat",
                maskSize: "cover",
                maskPosition: "center",
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "cover",
                WebkitMaskPosition: "center", 
                height: "550px",
                width: "600px"
              }}
            />
          </div>
        </div>
      </section>

      <section>
        <FounderSection/>
        {/* <Blog/> */}
        {/* <DeliverySlide/> */}
        {/* <FarmersVideo/> */}
        {/* <Help/> */}
        {/* <PrivacyPolicy/> */}
        {/* <Promisepage/> */}
        {/* <Settings/> */}
        
        {/* <Terms/> */}
         
      </section>
    </div>
  );
}
